import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRecordingsAction,
  fetchRoomRecordingsAction,
  toggleRecordingAction,
  downloadRecordingAction,
  getRecordingsFromDbAction,
} from "../../actions/recording/recordingActions";

const recordingSlice = createSlice({
  name: "recording",
  initialState: {
    recordings: [],
    roomRecordings: [],
    loading: false,
    roomLoading: false,
    downloading: false,
    error: null,
    lastAction: null,
  },
  reducers: {
    setRecordings(state, action) {
      state.recordings = action.payload;
    },
    setRoomRecordings(state, action) {
      state.roomRecordings = action.payload;
    },
    clearRecordingError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(fetchRecordingsAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecordingsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.recordings = action.payload?.recordings || [];
        return state;
      })
      .addCase(fetchRecordingsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchRoomRecordingsAction.pending, (state, action) => {
        state.roomLoading = true;
      })
      .addCase(fetchRoomRecordingsAction.fulfilled, (state, action) => {
        state.roomLoading = false;
        state.roomRecordings = action.payload?.recordings || [];
        return state;
      })
      .addCase(fetchRoomRecordingsAction.rejected, (state, action) => {
        state.roomLoading = false;
        state.error = action.payload;
      })
      .addCase(toggleRecordingAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(toggleRecordingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.lastAction = action.payload?.action;
        return state;
      })
      .addCase(toggleRecordingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadRecordingAction.pending, (state, action) => {
        state.downloading = true;
      })
      .addCase(downloadRecordingAction.fulfilled, (state, action) => {
        state.downloading = false;
        return state;
      })
      .addCase(downloadRecordingAction.rejected, (state, action) => {
        state.downloading = false;
        state.error = action.payload;
      })
      .addCase(getRecordingsFromDbAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRecordingsFromDbAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(getRecordingsFromDbAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }),
});

export const { setRecordings, setRoomRecordings, clearRecordingError } = recordingSlice.actions;
export default recordingSlice.reducer;
